<template>
    <div class="modalInstall" v-if="shown">
        <span class="modalInstall__title">
            Добавить приложение на главный экран?
        </span>
        <div class="modalInstall__btnBlock">
            <button @click="installPWA" class="modalInstall__btnBlock__install">
                Установить
            </button>
            <button @click="dismissPrompt" class="modalInstall__btnBlock__close">
                Нет, спасибо
            </button>
        </div>
    </div>
</template>

<style scoped lang="scss" src="./style.scss"></style>

<script src="./script.js"></script>
